import { Download } from "lucide-react";
import { Transition } from "@headlessui/react";
import { panelClasses } from "../utils/constants";

const ExportThread = ({ messages, isOpen, setIsOpen, closeOthers }) => {
  const buildMarkdownExport = () => {
    let md = "# Chat Export\n\n";
    md += `*Exported on ${new Date().toLocaleString()}*\n\n---\n\n`;
    messages.forEach((entry) => {
      if (entry.type === "question") {
        md += `**You:**\n${entry.question}\n\n`;
      } else if (entry.type === "answer") {
        md += `**Assistant${entry.agent ? ` (${entry.agent})` : ""}:**\n${entry.answer}\n\n`;
        if (entry.sources?.length > 0) {
          md += `*Sources: ${entry.sources.join(", ")}*\n\n`;
        }
        md += "---\n\n";
      }
    });
    return md;
  };

  const downloadFile = (content, filename, mimeType) => {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const exportMarkdown = () => {
    const md = buildMarkdownExport();
    downloadFile(md, "chat-export.md", "text/markdown");
    setIsOpen(false);
  };

  const exportPdf = () => {
    const md = buildMarkdownExport();
    const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>Chat Export</title>
<style>
  body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 800px; margin: 40px auto; padding: 0 20px; color: #1a1a1a; line-height: 1.6; font-size: 14px; }
  h1 { font-size: 20px; border-bottom: 1px solid #e5e5e5; padding-bottom: 8px; }
  hr { border: none; border-top: 1px solid #e5e5e5; margin: 16px 0; }
  strong { font-weight: 600; }
  em { color: #666; }
  code { background: #f4f4f5; padding: 2px 6px; border-radius: 4px; font-size: 13px; }
  pre { background: #f4f4f5; padding: 12px; border-radius: 8px; overflow-x: auto; }
  pre code { background: none; padding: 0; }
</style></head><body>${md
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/^# (.+)$/gm, "<h1>$1</h1>")
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/\*(.+?)\*/g, "<em>$1</em>")
      .replace(/`(.+?)`/g, "<code>$1</code>")
      .replace(/^---$/gm, "<hr>")
      .replace(/\n\n/g, "</p><p>")
      .replace(/\n/g, "<br>")}</body></html>`;

    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.write(html);
      printWindow.document.close();
      setTimeout(() => {
        printWindow.print();
      }, 250);
    }
    setIsOpen(false);
  };

  const hasMessages = messages.length > 0;

  return (
    <div>
      <button
        onClick={() => {
          if (!hasMessages) return;
          closeOthers?.();
          setIsOpen(!isOpen);
        }}
        className={[
          "inline-flex items-center gap-1.5 py-1 transition-colors",
          hasMessages
            ? "text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200"
            : "text-zinc-300 dark:text-zinc-700 cursor-not-allowed",
        ].join(" ")}
      >
        <Download className="h-3.5 w-3.5" strokeWidth={2} />
        <span className="text-[13px]">Export</span>
      </button>

      <Transition
        show={isOpen}
        enter="transition duration-150 ease-out"
        enterFrom="opacity-0 translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="transition duration-100 ease-in"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <div className="absolute left-0 right-0 bottom-full z-[70]">
          <div className={panelClasses}>
            <div className="p-2 space-y-0.5">
              <button
                onClick={exportMarkdown}
                className="w-full flex items-center gap-2 rounded-md px-3 py-2 text-left text-[13px] text-zinc-700 dark:text-zinc-300 hover:bg-zinc-50 dark:hover:bg-zinc-800/50 transition-colors"
              >
                <span>📄</span>
                <span>Export as Markdown</span>
              </button>
              <button
                onClick={exportPdf}
                className="w-full flex items-center gap-2 rounded-md px-3 py-2 text-left text-[13px] text-zinc-700 dark:text-zinc-300 hover:bg-zinc-50 dark:hover:bg-zinc-800/50 transition-colors"
              >
                <span>📑</span>
                <span>Export as PDF</span>
              </button>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default ExportThread;
